import { render, staticRenderFns } from "./PpgGenerationResult.vue?vue&type=template&id=5c0d9a27&scoped=true"
import script from "./PpgGenerationResult.vue?vue&type=script&lang=js"
export * from "./PpgGenerationResult.vue?vue&type=script&lang=js"
import style0 from "./PpgGenerationResult.vue?vue&type=style&index=0&id=5c0d9a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d9a27",
  null
  
)

export default component.exports